import { IPage } from '@/types';
import { BlogDetails } from '@/types/types/Pages';

export default function getPageBanner(pageDetails: IPage | BlogDetails | undefined) {
  const { name = '', banner = '', banner_optimized = undefined } = pageDetails || {};

  return banner ? {
    src: banner,
    alt: name,
    large: banner_optimized?.large ?? banner,
    medium: banner_optimized?.medium ?? banner,
    small: banner_optimized?.small ?? banner,
  } : undefined;
}
